<template>
    <div class="container" >
        <div>
            <Head @changeOn="changeOn"></Head>
        </div>
        <div class="content">
            <div class="item" @click="showPopup(index=1)">
                <span>省份</span>
                <input type="text" placeholder=""  readonly v-model="info.province">
                <label></label>
            </div>
            <div class="item" @click="showPopup(index=2)">
                <span>城市</span>
                <input type="text" placeholder=""  readonly v-model="info.city">
                <label></label>
            </div>
            <div class="item" @click="showPopup(index=3)">
                <span>医院级别</span>
                <input type="text" placeholder=""  readonly v-model="info.level">
                <label></label>
            </div>
            <div class="item" @click="showPopup(index=4)">
                <span>科室</span>
                <input type="text" placeholder=""  readonly v-model="info.department">
                <label></label>
            </div>
            <div class="item" @click="showPopup(index=5)">
                <span>职称</span>
                <input type="text" placeholder="" readonly v-model="info.title">
                <label></label>
            </div>
            <div class="submit" @click="toSubmit">
                <span>进入直播间</span>
            </div>

            <mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true"
                      position="bottom">
                <mt-picker :slots="slots" @change="slotValueChange" showToolbar>
                    <div class="picker-toolbar-title">
                        <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">取消</div>
                        <div class="">请选择</div>
                        <div class="usi-btn-sure" @click="slotValueAdd">确定</div>
                    </div>
                </mt-picker>
            </mt-popup>

        </div>
    </div>
</template>

<script>
    import {tvInfo} from "@/assets/js/api";
    import crypto from "crypto";
    import Head from "../hz/Head"
    export default {
        components:{
            Head
        },
        data() {
            return {
                popupVisible:false,
                slots: [
                    {
                        values: [],
                    }
                ],
                slotSure:"",
                index:0,
                info:{
                    province:"",
                    city:"",
                    title:"",
                    department:"",
                    level:"",
                    company:"辉致",
                    name:""
                },
                countryArr : require("../../mock/country.json"),
                link:"814235"
            }
        },
        methods: {
            changeOn(val){
                console.log("onOrOff="+val)
                if (val){
                    this.$parent.$refs.audio.pause();
                }else{
                    this.$parent.$refs.audio.play();
                }
                //
            },
            showPopup(index){
                console.log(index)
                switch (index) {
                    case 1:
                        this.getProvince()
                        break;
                    case 2:
                        if(this.info.province==""){
                            this.$toast("请先选择省份")
                            return
                        }
                        this.getCity()
                        break;
                    case 3:
                        this.slots[0].values = ['三级医院','二级医院','一级医院','其他']
                        break;
                    case 4:
                        this.slots[0].values = ['心内科', '肾内科', '神经内科','内分泌科','老年科','全科','其他']
                        break
                    case 5:
                        this.slots[0].values = ["主任医师","副主任医师","主治医师","住院医师","其他"]
                        break
                }
                this.popupVisible = true
            },
            slotValueChange(picker, values) {
                this.slotSure = values[0];
            },
            slotValueAdd() {
                this.popupVisible = !this.popupVisible
                switch (this.index) {
                    case 1:
                        this.info.province = this.slotSure
                        this.info.city =""
                        break;
                    case 2:
                        this.info.city = this.slotSure
                        break;
                    case 3:
                        this.info.level=this.slotSure
                        break;
                    case 4:
                        this.info.department=this.slotSure
                        break;
                    case 5:
                        this.info.title=this.slotSure
                        break;
                }
            },
            getProvince(){
                this.slots[0].values=[]
                for(let item of this.countryArr[0].children){
                    this.slots[0].values.push(item.value)
                }
            },
            getCity(){
                this.slots[0].values=[]
                for(let item of this.countryArr[0].children){
                    if(item.value.indexOf(this.info.province)!=-1){
                        for(let items of item.children){
                            this.slots[0].values.push(items.value)
                            // console.log(items.value,",city")
                        }
                        break
                    }
                }
            },
            toSubmit(){
                if(this.info.province==""){
                    this.$toast("请选择省份")
                    return;
                }

                if(this.info.city==""){
                    this.$toast("请选择城市")
                    return;
                }

                if(this.info.level==""){
                    this.$toast("请选择医院级别")
                    return;
                }

                if(this.info.department==""){
                    this.$toast("请选择科室")
                    return;
                }
                if(this.info.title==""){
                    this.$toast("请选择职称")
                    return;
                }
                let userid= this.randomUserId();//随机id
                this.info.name=userid
                this.submit(this.info,userid)

            },
            async submit(info,userid){
                const res = await tvInfo(info)
                if(res.data.code===200){
                    const md5 = crypto.createHash('md5')
                    md5.update(userid+"")
                    let key = md5.digest('hex')
                    let name = "用户-"+userid
                    let  url =  "http://mudu.tv/activity.php?a=userAssign&id="+this.link+"&userid="+userid+"&name="+name+"&key="+key
                    window.location.replace(url)

                }
                console.log(res)
            },
            randomUserId(){
                let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T'
                    ,'U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
                let nums="";
                for(let i=0;i<16;i++){//这里是几位就要在这里不改变
                    let id = parseInt(Math.random()*61);
                    nums+=chars[id];
                }
                return nums;
            }
        },
        mounted(){
            let audio = document.getElementById("audio")
            audio.style.display = "none"
            localStorage.setItem("isOff","false")
        }
    }
</script>

<style lang="scss" scoped>
    .container{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/bg-1.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        overflow: scroll;
        color: #FFF;
        font-size: 14px;
        display: flex;
    }

    .container .content{
        margin-top: 20px;
    }

    .container .content .item{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.2);

        width: 80% ;
        margin: 0 auto 20px auto;
        border-radius: 5px;
        padding: 5px 0;

        span{
            text-align: left;
            color: #FFF;
            margin: 2px 10px;
            white-space: nowrap;
        }
        label{
            width: 8px;
            height: 8px;
            border-right: 2px solid #FFF;
            border-top: 2px solid #FFF;
            margin-right: 10px;
            transform: rotate(45deg);

        }
    }

    .submit{
        width: 100%;
        margin-bottom: 20px;
    }

    .submit span{
        width: 80%;
        background: #036eb7;
        border-radius: 10px;
        display: block;
        margin: 30px auto 0 auto;
        padding: 8px 0;
    }

    input{
        border: none;
        outline: none;
        background: transparent;
        font-size: 14px;
        color: #FFF;
        text-indent: 5px;
        flex-grow: 1;
    }

    .popup {
        width: 100%;
    }

    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    .usi-btn-cancel,
    .usi-btn-sure {
        color: #036eb7;
    }
</style>
